import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { StorageService } from '@app/data/browser/storage.service';
import { AppFacade } from '@app/facades/app.facade';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PurchaselessOnboardingGuard implements CanActivate {
  constructor(private _storageService: StorageService, private _appFacade: AppFacade) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    this._storageService.removeAllItems();
    this._appFacade.setPurchaseLessOnboardingFlag(true);
    return true;
  }
}
